// src/views/CartView.jsx
import React from "react";
import { Trash2, Minus, Plus } from "lucide-react";
import { Link } from "react-router-dom";
import { useCart } from "../context/CartContext";

const CartView = () => {
  const { cartItems, addToCart, removeFromCart, updateQuantity } = useCart();

  const subtotal = cartItems.reduce(
    (acc, item) => acc + (item.precio || 0) * item.cantidad,
    0
  );
  const taxes = subtotal * 0.1;
  const total = subtotal + taxes;

  return (
    <div
      className="relative flex size-full min-h-screen flex-col bg-white overflow-x-hidden"
      style={{ fontFamily: '"Plus Jakarta Sans", "Noto Sans", sans-serif' }}
    >
      <div className="layout-container flex h-full grow flex-col">
        <div className="px-6 md:px-40 flex flex-1 justify-center py-5">
          <div className="layout-content-container flex flex-col max-w-[960px] flex-1">
            <div className="flex flex-wrap justify-between gap-3 p-4">
              <p className="text-[#141414] text-[32px] font-bold">
                Carrito de compras
              </p>
            </div>

            {cartItems.length === 0 ? (
              <p className="px-4 text-[#757575]">Tu carrito está vacío.</p>
            ) : (
              cartItems.map((item) => (
                <div
                  key={item.id}
                  className="flex items-center gap-4 bg-white px-4 min-h-[72px] py-2 justify-between border-b"
                >
                  <div className="flex items-center gap-4">
                    <div
                      className="bg-center bg-no-repeat aspect-square bg-cover rounded-lg size-14"
                      style={{
                        backgroundImage: item.imagen
                          ? `url("${item.imagen}")`
                          : 'url("https://via.placeholder.com/80")',
                      }}
                    ></div>
                    <div className="flex flex-col justify-center">
                      <p className="text-[#141414] text-base font-medium">
                        {item.nombre}
                      </p>
                      <div className="flex items-center gap-2 text-sm text-[#757575]">
                        <div className="flex items-center border rounded-md px-2">
                          <button
                            onClick={() => updateQuantity(item.id, -1)}
                            className="p-1"
                          >
                            <Minus size={14} />
                          </button>
                          <span className="px-2">{item.cantidad}</span>
                          <button
                            onClick={() => updateQuantity(item.id, 1)}
                            className="p-1"
                          >
                            <Plus size={14} />
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="flex items-center gap-4">
                    <p className="text-[#141414] text-base">
                      ${(item.precio || 0) * item.cantidad}
                    </p>
                    <button
                      onClick={() => removeFromCart(item.id)}
                      className="text-red-500 hover:text-red-700"
                    >
                      <Trash2 size={18} />
                    </button>
                  </div>
                </div>
              ))
            )}

            {cartItems.length > 0 && (
              <>
                <h3 className="text-[#141414] text-lg font-bold px-4 pb-2 pt-4">
                  Resumen del pedido
                </h3>
                <div className="p-4">
                  <div className="flex justify-between py-2">
                    <p className="text-[#757575] text-sm">Subtotal</p>
                    <p className="text-[#141414] text-sm">
                      ${subtotal.toFixed(2)}
                    </p>
                  </div>
                  <div className="flex justify-between py-2">
                    <p className="text-[#757575] text-sm">Envío</p>
                    <p className="text-[#141414] text-sm">Gratis</p>
                  </div>
                  <div className="flex justify-between py-2">
                    <p className="text-[#757575] text-sm">Impuestos</p>
                    <p className="text-[#141414] text-sm">
                      ${taxes.toFixed(2)}
                    </p>
                  </div>
                  <div className="flex justify-between py-2 font-bold">
                    <p className="text-[#141414] text-sm">Total</p>
                    <p className="text-[#141414] text-sm">
                      ${total.toFixed(2)}
                    </p>
                  </div>
                </div>

                <div className="flex px-4 py-3 justify-end">
                  <Link
                    to="/registro-ordenes"
                    className="flex items-center justify-center rounded-lg h-12 px-5 bg-[#141414] text-white text-base font-bold hover:bg-black/80"
                  >
                    Ir al registro de pedido
                  </Link>
                </div>
              </>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default CartView;
